import {easeInQuartFollow} from 'modules/ease.js';

export default function () {

    return easeInQuartFollow;
};
